module.exports = __webpack_public_path__ + "img/icon-filter.13629ebc.svg";